const TRANSPORT_ICON_CLASSES: Record<string, string> = {
  plane: "las la-plane",
  ship: "las la-ship",
  train: "las la-train",
  bus: "las la-bus",
  taxi: "las la-taxi",
  car: "las la-car",
  motorcycle: "las la-motorcycle",
  bicycle: "las la-bicycle",
  walking: "las la-walking",
};

export const getTransportIconClass = (
  typeTransport?: string | null
): string | null => {
  if (!typeTransport) return null;

  return TRANSPORT_ICON_CLASSES[typeTransport.toLowerCase()] || null;
};

